import { ApiModelVersionDataPoint } from 'src/api/queries';
import { formatDate } from 'src/utils/date';

export const getModelDateString = (model: ApiModelVersionDataPoint) => {
  const startDate = formatDate('YYYY-MM-DD', model.dataStartDate);
  const endDate = formatDate('YYYY-MM-DD', model.dataEndDate);
  return `${startDate} - ${endDate}`;
};
